import {Component, inject} from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {heroArrowRightStartOnRectangle} from '@ng-icons/heroicons/outline';
import {Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';

@Component({
  selector: 'app-header',
  imports: [NgIcon],
  providers: [provideIcons({ heroArrowRightStartOnRectangle })],
  template: `
    <div class="navbar border-b border-base-300 bg-base-100 px-4 md:px-6">
      <div class="flex-1">
        <div class="flex flex-col">
          <span class="text-[0.65rem] font-semibold uppercase tracking-[0.35em] text-base-content/50">
            Prezzemolo e Vitale
          </span>
          <span class="text-base font-semibold text-base-content">
            Timbratore
          </span>
        </div>
      </div>

      <div class="flex-none flex items-center gap-1">
        <button class="btn btn-ghost btn-circle" aria-label="Logout" (click)="logout($event)">
          <ng-icon name="heroArrowRightStartOnRectangle" size="20" />
        </button>
      </div>
    </div>
  `,
  styles: ``
})
export class HeaderComponent {
  auth = inject(AuthService);
  router = inject(Router);

  logout(e: Event): void{
    e.preventDefault();
    this.auth.logout();
    this.router.navigate(['/login']);
  }
}
